import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

interface ServicePageProps {
    id: string;
    route?: string;
    title?: string;
    description?: string;
    image?: string;
}

interface ServiceState {
    id: string;
    route?: string;
    title: string;
    description: string;
    image: string;
    translations: Record<string, any>;
}

class ServiceBox extends Component<ServicePageProps, ServiceState> {
    constructor(props: ServicePageProps) {
        super(props);
        const translations = JSON.parse(localStorage.getItem('translations') || '[]');
        this.state = { 
            id: this.props.id, 
            route: this.props.route,
            title: this.props.title || "", 
            description: this.props.description || "",
            image: this.props.image || "",
            translations: translations
        };
    }

    render() {
        return (
            <div className="mb-3 oc-service-box">
                <Row>
                    <Col lg={5} md={5} sm={6} xs={6}>
                        <figure 
                            className="oc-service-image" 
                            style={{ backgroundImage: `url(${this.state?.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        </figure>
                    </Col>
                    <Col lg={7} md={7} sm={6} xs={6}>
                        <p className="oc-service-text">{this.state?.description}</p>
                        <h2 className="oc-service-title">{this.state?.title}</h2>
                        <Link to={`${this.state.route}`} className="oc-service-link">
                            <span className="">{this.state.translations.filter((item: any) => item.setting_name === 'TOVABB')[0]?.setting_value_text || 'Tovább'}</span> 
                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.0454 7.81824L9.04541 1.81824L15.0454 7.81824ZM15.0454 7.81824L9.04541 13.8182L15.0454 7.81824ZM15.0454 7.81824H1.04541H15.0454Z" fill="#D22024"/>
                                <path d="M15.0454 7.81824L9.04541 1.81824M15.0454 7.81824L9.04541 13.8182M15.0454 7.81824H1.04541" stroke="#D22024" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </Link>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ServiceBox;